
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91title_93zyY95AqT_45IGSJB71e4Y3v_n5_45LbUBRaUxsN3oxgtX2QMeta } from "/vercel/path0/apps/eb-builder/pages/error/[title].vue?macro=true";
import { default as builderL_R5Ood25u810Z0jaYhajtVXAWeMH3vXnpUDr8E3AAoMeta } from "/vercel/path0/apps/eb-builder/pages/[sessionId]/builder.vue?macro=true";
import { default as _91id_937OEk9zJNlfF4kL5RHXLRUtR_m7Okfv9Oi6IOlK8e08cMeta } from "/vercel/path0/apps/eb-builder/pages/[type]-session/[id].vue?macro=true";
import { default as indexwx6Cg7_mCu4iA6jtop2TXv_I9MzQZrySHcn8BNVRQGoMeta } from "/vercel/path0/apps/eb-builder/pages/[sessionId]/browser/index.vue?macro=true";
import { default as _91templateId_93gNDM5wCxwe_45k_452yvYH9EFsGsywxPRqYN3mLpfq3_qV4Meta } from "/vercel/path0/apps/eb-builder/pages/[sessionId]/browser/templates/[templateId].vue?macro=true";
export default [
  {
    name: "error-title",
    path: "/error/:title()",
    meta: _91title_93zyY95AqT_45IGSJB71e4Y3v_n5_45LbUBRaUxsN3oxgtX2QMeta || {},
    component: () => import("/vercel/path0/apps/eb-builder/pages/error/[title].vue")
  },
  {
    name: "sessionId-builder",
    path: "/:sessionId()/builder",
    meta: builderL_R5Ood25u810Z0jaYhajtVXAWeMH3vXnpUDr8E3AAoMeta || {},
    component: () => import("/vercel/path0/apps/eb-builder/pages/[sessionId]/builder.vue")
  },
  {
    name: "type-session-id",
    path: "/:type()-session/:id()",
    meta: _91id_937OEk9zJNlfF4kL5RHXLRUtR_m7Okfv9Oi6IOlK8e08cMeta || {},
    component: () => import("/vercel/path0/apps/eb-builder/pages/[type]-session/[id].vue")
  },
  {
    name: "sessionId-browser",
    path: "/:sessionId()/browser",
    meta: { ...(indexwx6Cg7_mCu4iA6jtop2TXv_I9MzQZrySHcn8BNVRQGoMeta || {}), ...{"middleware":["clean-query"]} },
    component: () => import("/vercel/path0/apps/eb-builder/pages/[sessionId]/browser/index.vue")
  },
  {
    name: "sessionId-browser-templates-templateId",
    path: "/:sessionId()/browser/templates/:templateId()",
    meta: _91templateId_93gNDM5wCxwe_45k_452yvYH9EFsGsywxPRqYN3mLpfq3_qV4Meta || {},
    component: () => import("/vercel/path0/apps/eb-builder/pages/[sessionId]/browser/templates/[templateId].vue")
  }
]